import api from './api';
// 新增新闻
export function addNews(params) {
  return api.post('/news/save.html', params).then(res => res.data);
}
export function list(params) {
  return api.post('/news/list.html', params, false, false).then(res => res.data);
}

export function deleteNews(params) {
  return api.post('/news/delete.html', params).then(res => res);
}
// 根据newsId获取新闻详情
export function getNewsDetail(params) {
  return api.post('/news/info', params).then(res => res);
}
// 根据数据字典ID获取数据字典项
export function getdiclistbypid(params) {
  return api.post('/dic/getdiclistbypid.html', params, false, false).then(res => res);
}
// 审核新闻
export function setstate(params) {
  return api.post('/news/setstate.html', params, false, false).then(res => res);
}



// WEBPACK FOOTER //
// ./src/api/industryIdynamics.js